import { Switch } from "antd";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { MaintenanceSettings } from "../Maintenance";
const SettingsPage = () => {
  // Underhållsfönstret är en global systeminställning och visas bara för admin.
  // Backend gör samma kontroll oberoende av detta — att dölja i UI är
  // bekvämlighet, inte skydd.
  const roles = useSelector((state) => state.auth.userData?.roles) || [];
  const isAdmin = roles.includes("admin");
  const [exportStartStop, setExportStartStop] = useState((localStorage.getItem("export_start_stop") || "1") === "1");
  const [subzoneMovable, setSubzoneMovable] = useState((localStorage.getItem("subzone_movable") || "1") === "1");
  function onSwitchExportChange(value) {
    localStorage.setItem("export_start_stop", value ? "1" : "0");
    setExportStartStop(value);
  }
  function onSwitchMoveSubzoneChange(value) {
    localStorage.setItem("subzone_movable", value ? "1" : "0");
    setSubzoneMovable(value);
  }
  // TODO: Create "SettingsSwitch"-component which sets localstorage value and displays the switch, label as well as their containing div.
  return (
    <div className="Content SettingsPage">
      <div className="ContentHeader">
        <div className="HeaderTitle">
          Inställningar
        </div>
      </div>
      <div style={{display: "flex", flexDirection: "column", gap: "1em"}}>
        <div style={{display: "flex", alignItems: "center", gap: "1em"}}>
          <Switch checked={exportStartStop} onChange={onSwitchExportChange} id="exportStartStopSwitch"></Switch>
          <label htmlFor="exportStartStopSwitch" style={{fontSize: "1.5em", userSelect: "none"}}> Exportera start/stop i delzoner</label>
        </div>
        <div style={{display: "flex", alignItems: "center", gap: "1em"}}>
          <Switch checked={subzoneMovable} onChange={onSwitchMoveSubzoneChange} id="subzoneMovableSwitch"></Switch>
          <label htmlFor="subzoneMovableSwitch" style={{fontSize: "1.5em", userSelect: "none"}}> Dra för att flytta områden för delzoner</label>
        </div>
      </div>
      {isAdmin ? <MaintenanceSettings /> : null}
    </div>
  );
};

export default SettingsPage;
